import React, { useEffect } from "react";
import WebFont from "webfontloader";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

function Head() {
  const { id } = useParams();
  const { slug } = useParams();

  useEffect(() => {
    // If your head code includes any google fonts, place them here
    WebFont.load({
      google: {
        families: ["Open Sans:300,300italic,400,400italic,600,600italic,700,700italic,800,800italic"],
      },
    });
  }, []);

  //   Depending on the page we're on, we'll want different head tags. make a 'case' for each page slug,
  //   Convert your webflow <head></head> code to JSX and paste it between these <Helmet></Helmet> tags
  switch (window.location.pathname) {
    case "/":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>23 Air Cadets</title>
          <meta
            content="A fun place to spend your Monday nights making friends and learning about aviation, survival, the Canadian Forces and participating in activities including sports, music, drill, marksmanship, field training exercise, and so much more!"
            name="description"
          />
          <meta content="Royal Canadian Air Cadets Aviation, Aerospace, Drill, Music, Fitness, Leadership, Marksmanship and so much more!" property="og:title" />
          <meta
            content="A fun place to spend your Monday nights making friends and learning about aviation, survival, the Canadian Forces and participating in activities including sports, music, drill, marksmanship, field training exercise, and so much more!"
            property="og:description"
          />
          <meta content="https://uploads-ssl.webflow.com/634efd6b20b65bfc05be44e4/635015c5a5382a4e99192991_temp%20donation.jpg" property="og:image" />
          <meta content="Royal Canadian Air Cadets Aviation, Aerospace, Drill, Music, Fitness, Leadership, Marksmanship and so much more!" property="twitter:title" />
          <meta
            content="A fun place to spend your Monday nights making friends and learning about aviation, survival, the Canadian Forces and participating in activities including sports, music, drill, marksmanship, field training exercise, and so much more!"
            property="twitter:description"
          />
          <meta content="https://uploads-ssl.webflow.com/634efd6b20b65bfc05be44e4/635015c5a5382a4e99192991_temp%20donation.jpg" property="twitter:image" />
          <meta property="og:type" content="website" />
          <meta content="summary_large_image" name="twitter:card" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case "/about":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>About Us</title>
          <meta
            content="Air Cadets is a National Youth Movement which helps youth become better citizens, better leaders and better people in general. The three Aims of Air Cadets are simple: To Develop in Youth the Attributes of Good Citizenship and Leadership; To Promote Physical Fitness; and to stimulate an Interest in the Air Element of the Canadian Forces. We want to give your son/daughter opportunities that they otherwise would not be open to outside of our organization and, in the process, help them grow. If you have questions, or would like further information, please feel free to speak to any one of our Staff members or Squadron Sponsoring Committee members at the Squadron at any time. Further information about the Air Cadet Program may be found at: ‍‍www.cadets.ca"
            name="description"
          />
          <meta content="About Us" property="og:title" />
          <meta
            content="Air Cadets is a National Youth Movement which helps youth become better citizens, better leaders and better people in general. The three Aims of Air Cadets are simple: To Develop in Youth the Attributes of Good Citizenship and Leadership; To Promote Physical Fitness; and to stimulate an Interest in the Air Element of the Canadian Forces. We want to give your son/daughter opportunities that they otherwise would not be open to outside of our organization and, in the process, help them grow. If you have questions, or would like further information, please feel free to speak to any one of our Staff members or Squadron Sponsoring Committee members at the Squadron at any time. Further information about the Air Cadet Program may be found at: ‍‍www.cadets.ca"
            property="og:description"
          />
          <meta content="https://uploads-ssl.webflow.com/634efd6b20b65bfc05be44e4/63500360793a8b2f2b2f7177_airplanes.jpg" property="og:image" />
          <meta content="About Us" property="twitter:title" />
          <meta
            content="Air Cadets is a National Youth Movement which helps youth become better citizens, better leaders and better people in general. The three Aims of Air Cadets are simple: To Develop in Youth the Attributes of Good Citizenship and Leadership; To Promote Physical Fitness; and to stimulate an Interest in the Air Element of the Canadian Forces. We want to give your son/daughter opportunities that they otherwise would not be open to outside of our organization and, in the process, help them grow. If you have questions, or would like further information, please feel free to speak to any one of our Staff members or Squadron Sponsoring Committee members at the Squadron at any time. Further information about the Air Cadet Program may be found at: ‍‍www.cadets.ca"
            property="twitter:description"
          />
          <meta content="https://uploads-ssl.webflow.com/634efd6b20b65bfc05be44e4/63500360793a8b2f2b2f7177_airplanes.jpg" property="twitter:image" />
          <meta property="og:type" content="website" />
          <meta content="summary_large_image" name="twitter:card" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
          <link rel="stylesheet" href="https://fengyuanchen.github.io/datepicker/css/datepicker.css" />
        </Helmet>
      );

    case "/absence":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Absence</title>
          <meta content="Absence" property="og:title" />
          <meta content="Absence" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case "/calendar":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Calendar</title>
          <meta content="Calendar" property="og:title" />
          <meta content="Calendar" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case "/contact":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Contact Us</title>
          <meta content="E-mail: 151rcacs@gmail.com Telephone:  (905) 576-1511 Mailing Address: 1288 Ritson Road North Oshawa, ON L1G 8B2" name="description" />
          <meta content="Contact Us" property="og:title" />
          <meta content="E-mail: 151rcacs@gmail.com Telephone:  (905) 576-1511 Mailing Address: 1288 Ritson Road North Oshawa, ON L1G 8B2" property="og:description" />
          <meta content="https://uploads-ssl.webflow.com/634efd6b20b65bfc05be44e4/635015c5a5382a4e99192991_temp%20donation.jpg" property="og:image" />
          <meta content="Contact Us" property="twitter:title" />
          <meta content="E-mail: 151rcacs@gmail.com Telephone:  (905) 576-1511 Mailing Address: 1288 Ritson Road North Oshawa, ON L1G 8B2" property="twitter:description" />
          <meta content="https://uploads-ssl.webflow.com/634efd6b20b65bfc05be44e4/635015c5a5382a4e99192991_temp%20donation.jpg" property="twitter:image" />
          <meta property="og:type" content="website" />
          <meta content="summary_large_image" name="twitter:card" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
          <link rel="stylesheet" href="https://fengyuanchen.github.io/datepicker/css/datepicker.css" />
        </Helmet>
      );

    case "/donate":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Donate</title>
          <meta content="Donate" property="og:title" />
          <meta content="Donate" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case "/login":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Log into Air Cadets</title>
          <meta content="Start your educational adventure by logging onto your air cadet account." name="description" />
          <meta content="Log into Air Cadets" property="og:title" />
          <meta content="Start your educational adventure by logging onto your air cadet account." property="og:description" />
          <meta content="Log into Air Cadets" property="twitter:title" />
          <meta content="Start your educational adventure by logging onto your air cadet account." property="twitter:description" />
          <meta property="og:type" content="website" />
          <meta content="summary_large_image" name="twitter:card" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case `/newsletter/${id}`:
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Newsletter</title>
          <meta content="Newsletter" property="og:title" />
          <meta content="Newsletter" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="../css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="../css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="../css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case "/gallery":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Photos</title>
          <meta content="Photos" property="og:title" />
          <meta content="Photos" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case "/profile":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Profile</title>
          <meta content="Parent/Cadet information" property="og:title" />
          <meta content="Parent/Cadet information" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          {/* [if lt IE 9]><![endif] */}
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case `/resources/${id}`:
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Resource</title>
          <meta content="Resource" property="og:title" />
          <meta content="Resource" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="../css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="../css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="../css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    case "/resources":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Resources</title>
          <meta content="Resources" property="og:title" />
          <meta content="Resources" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
          <link rel="stylesheet" href="https://fengyuanchen.github.io/datepicker/css/datepicker.css" />
        </Helmet>
      );

    case "/sign-up":
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>Join 23 Air Cadets</title>
          <meta content="This youth-focused program is open to all young people aged 12 to 18." name="description" />
          <meta content="Join 23 Air Cadets" property="og:title" />
          <meta content="This youth-focused program is open to all young people aged 12 to 18." property="og:description" />
          <meta content="Join 23 Air Cadets" property="twitter:title" />
          <meta content="This youth-focused program is open to all young people aged 12 to 18." property="twitter:description" />
          <meta property="og:type" content="website" />
          <meta content="summary_large_image" name="twitter:card" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
          <link rel="stylesheet" href="https://fengyuanchen.github.io/datepicker/css/datepicker.css" />
        </Helmet>
      );

    case `/${encodeURIComponent(slug)}`:
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>{slug}</title>
          <meta content="Template" property="og:title" />
          <meta content="Template" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );

    default:
      return (
        <Helmet>
          <meta charSet="utf-8" />
          <title>404 Not Found</title>
          <meta content="Not Found" property="og:title" />
          <meta content="Not Found" property="twitter:title" />
          <meta content="width=device-width, initial-scale=1" name="viewport" />
          <meta content="Webflow" name="generator" />
          <link href="css/normalize.css" rel="stylesheet" type="text/css" />
          <link href="css/webflow.css" rel="stylesheet" type="text/css" />
          <link href="css/23-air-cadets.webflow.css" rel="stylesheet" type="text/css" />
          <link href="images/favicon.png" rel="shortcut icon" type="image/x-icon" />
          <link href="images/webclip.png" rel="apple-touch-icon" />
        </Helmet>
      );
  }
}

export default Head;
